import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'home',
        component: () => import('@/views/Home/index.vue')
      },
      {
        path: 'owningInitial',
        name: 'owningInitial',
        component: () => import('@/views/Home/owning/index.vue')
      },
      {
        path: 'owningDetail/:name/:code/:schoolid',
        name: 'owningDetail',
        component: () => import('@/views/Home/owning/detail.vue')
      },
      {
        path: 'owned',
        name: 'owned',
        component: () => import('@/views/Home/owned/index.vue')
      },
      {
        path: 'detailMsg/:code/:pwd/:schoolid',
        name: 'detailMsg',
        component: () => import('@/views/Home/owned/detailMsg.vue')
      },
      {
        path: 'success',
        name: 'success',
        component: () => import('@/views/Home/success.vue')
      },
      {
        path: 'succeed',
        name: 'succeed',
        component: () => import('@/views/Home/succeed.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
